import { useAuth } from "@/context/AuthContext";
import GenericDashboard from "@/pages/GenericDashboard";
import PlannerDashboard from "@/pages/dashboards/PlannerDashboard";
import SuperintendentDashboard from "@/pages/dashboards/SuperintendentDashboard";
import SupervisorDashboard from "@/pages/dashboards/SupervisorDashboard";

/**
 * Dispatches to a role-specific dashboard based on the current user's role.
 * Backend RoleChangeReq enum: tradesman | supervisor | superintendent | owner
 * We also map admin / control / manager to Supervisor view (action-oriented).
 */
export default function Dashboard() {
  const { user } = useAuth();
  const role = String(user?.role || "").toLowerCase();

  if (role.includes("planner")) return <PlannerDashboard />;
  if (role.includes("superintendent") || role === "super") return <SuperintendentDashboard />;
  // Owner, admin and control operate at the action layer too — give them the
  // Supervisor view so Start Swing + Live Progress Tracker are visible.
  if (role.includes("supervisor") || role.includes("owner") || role.includes("admin") || role.includes("control") || role.includes("manager")) {
    return <SupervisorDashboard />;
  }

  return <GenericDashboard />;
}
